<template>
  <v-layout align-center justify-center class="pagemargin page">
    <div class="email-verified">
      <p>Your Email Address is successfully verified! Please login to access your account!</p>
      <v-btn
        :disabled="errors.any()"
        @click="login"
        round
        class="caption font-weight-light"
        color="primary"
      >Login</v-btn>
    </div>
  </v-layout>
</template>

<script>
import Vue from "vue";

export default {
  name: "email-verified",
  methods: {
    login: function() {
      this.$router.push("/authentication/login");
    }
  }
};
</script>

<style>
.email-verified {
  display: inline-block;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 70%;
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
  margin: 5%;
}

.email-verified p {
  font-size: 5vh;
  font-weight: bold;
  position: relative;
  margin: -8vh 0 0;
  padding: 0;
}

.email-verified p:after {
  content: attr(data-h1);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  color: transparent;
  /* webkit only for graceful degradation to IE */
  background: -webkit-repeating-linear-gradient(
    -45deg,
    #71b7e6,
    #69a6ce,
    #b98acc,
    #ee8176,
    #b98acc,
    #69a6ce,
    #9b59b6
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 400%;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.25);
  animation: animateTextBackground 10s ease-in-out infinite;
}
.email-verified p {
  color: #d6d6d6;
  font-size: 5vh;
  font-weight: bold;
  line-height: 10vh;
  max-width: 600px;
  position: relative;
  margin: 2%;
}
.email-verified h1 + p:after {
  content: attr(data-p);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  color: transparent;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.5);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
}
</style>